import Box, { type BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

type FlexProps = Omit<BoxProps, 'display'>;

const BaseFlex = forwardRef<unknown, FlexProps>((props: FlexProps, ref) => (
  <Box display='flex' {...props} ref={ref} />
));
BaseFlex.displayName = 'flex';

const Flex = styled(BaseFlex)``;

export { Flex };
export type { FlexProps };
